import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Flex, Text, Button, ButtonGroup } from '@chakra-ui/react';
import { useNavigate } from '@reach/router';
import { camelCase } from 'change-case';
import Heading from '#coreComponents/Heading';
import { useEnvironment } from '#core/Environment';
// JME
// import { useAuthHook } from '#utils/useAuthHook';
// JME1
import { useAuth } from '#core/Auth';

const NotFound: React.FC<{}> = () => {
  const {
    isAuthenticated,
    actions: { logIn },
  } = useAuth(); // JME2
  const { baseUrl } = useEnvironment();
  const navigate = useNavigate();
  const flags = useFlags();

  return (
    <Flex
      align="center"
      justify="center"
      textAlign="center"
      flexDirection="column"
      minH="calc(100vh - 380px)"
    >
      <Heading mb={3}>Page Not Found</Heading>
      <Text mb={3}>It looks like you've found a page that doesn't exist.</Text>
      <ButtonGroup spacing={8}>
        <Button
          variant="link"
          colorScheme="pink"
          onClick={() => navigate(new URL(baseUrl).pathname)}
        >
          {isAuthenticated ? 'Go to my dashboard' : 'Go home'}
        </Button>
        {!isAuthenticated && (
          <Button
            variant="link"
            colorScheme="pink"
            onClick={() =>
              flags[camelCase('auth0Enabled')]
                ? logIn()
                : logIn({ redirectUri: window.location.href })
            }
          >
            Log in
          </Button>
        )}
      </ButtonGroup>
    </Flex>
  );
};

export default NotFound;
